import * as React from 'react'
import gmcngineLogo from '../images/GMCNgine2.png';
import icmecLogo from '../images/logo-gmcn.png';

function PDHeader(): React.ReactElement {
  return (
    <div className="partners-dashboard__header box">
      <img src={gmcngineLogo} className="gmcngine-logo" alt="GMCNGINE Logo" />
      <div className="title">
        <h1>FOOTBALL CARES</h1>
        <h2>INTERNATIONAL MISSING CHILDREN'S DAY</h2>
        <h1>25 MAY</h1>
      </div>
      <img src={icmecLogo} className="icmec-logo" alt="ICMEC Logo"/>
    </div>
  )
}

export default React.memo(PDHeader);



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Partners/components/PDHeader.tsx